import axios from 'axios'
import store from '../state/store'
import AuthService from '../services/auth.service'

const DEFAULT_HEADERS = removeNullKeys({
  'Content-Type': 'application/json',
  'X-Access-Token': AuthService.getToken(),
})

const DEFAULT_HEADERS_FILES = removeNullKeys({
  'Accept': 'HTTP/1.1',
  'Cache-Control': true,
  'X-Access-Token': AuthService.getToken(),
})

const validStatuses = [
  200, 201, 202, 203, 204,
  300, 301, 302, 303, 304
]

/*
 * Returns default headers list
 * which will be used with every request.
 */
export function getHeaders (multipart = false) {
  let defaultHeaders = DEFAULT_HEADERS
  if (multipart) {
    defaultHeaders = {}
  }
  return defaultHeaders
}

export function getHeadersFiles (multipart = false) {
  let defaultHeaders = DEFAULT_HEADERS_FILES
  if (multipart) {
    defaultHeaders = {}
  }
  return defaultHeaders
}

export function checkResponse (response) {
  if (validStatuses.includes(response.status)) {
    return response
  }
  // If not authorized then reset token
  // and redirect to login page
  if (response.status === 401) {
    AuthService.deauthorize();
    return Promise.reject(new Error('USER_ANONYMOUS'))
  }
  let err = new Error(response.statusText)
  err.response = response
  const data = response.data
  err.detail = data && (data.detail || data.message)
    ? data.detail || data.message
    : 'Неизвестная ошибка, обратитесь в поддержку'
  return Promise.reject(err)
}

export function processAPIErrors (apiErrors) {
  let errors = {}
  if (apiErrors) {
    for (let key of Object.keys(apiErrors)) {
      let err = apiErrors[key]
      errors[key] = err
      // eslint-disable-next-line
      if (typeof err === Object || err.hasOwnProperty('length')) {
        errors[key] = apiErrors[key][0]
      }
    }
  }
  return errors
}

export const esc = encodeURIComponent

export function qs (params) {
  return (
    Object
      .keys(params)
      .map(k => esc(k) + '=' + esc(params[k]))
      .join('&')
  )
}

class Request {
  constructor (method, uri, params = {}) {
    this._isCancelled = false
    this._cancelTokenStorage = axios.CancelToken.source()
    this._request = axios({
      method,
      url: uri,
      cancelToken: this._cancelTokenStorage.token,
      ...params
    })
  }
  
  cancel () {
    this._isCancelled = true
    this._cancelTokenStorage.cancel()
  }
  
  get isCancelled () {
    return this._isCancelled
  }
  
  then (callback) {
    this._request.then(callback)
    return this;
  }
  
  catch (callback) {
    this._request.catch(callback)
    return this;
  }
  
  finally (callback) {
    this._request.finally(callback)
    return this;
  }
}


export function request (method, uri, params = {}) {
  return new Request(method, uri, params)
}

/*
 * Wraps axios and provides
 * more convenient post method
 * calls with data
 */
export function post (uri, data, postSettings = {}) {
  return request('post', uri, {
    data,
    headers: getHeaders(),
    ...postSettings
  })
}

export function postFiles (uri, data, postSettings = {}) {
  return request('post', uri, {
    data,
    headers: getHeadersFiles(),
    ...postSettings
  })
}

/*
 * Wraps axios and provides
 * more convenient put method
 * calls with data
 */
export function put (uri, data) {
  return request('put', uri, {
    data,
    headers: getHeadersFiles()
  })
}

/*
 * Wraps axios and provides
 * more convenient delete method
 */
export function remove (uri) {
  return request('delete', uri, {
    headers: getHeaders()
  })
}

/*
 * Wraps axios and provides
 * more convenient get method
 * calls with data.
 */
export function get (uri, params = {}) {
  return request('get', uri, {
    params,
    headers: getHeaders()
  })
}

export function upload (uri, data) {
  return fetch(uri, {
    headers: getHeaders(true),
    cors: true,
    method: 'POST',
    body: data
  })
}

// Base endpoint
export function e (uri) {
  return store.getters['auth/baseUrl'] + uri
}

// Auth settings
export function ae (uri) {
  return store.getters['auth/authUrl'] + uri
}

export function empty (uri) {
  return uri
}

export function removeNullKeys (obj) {
  let result = {}
  for (let key of Object.keys(obj)) {
    let value = obj[key]
    if (['', [], null, undefined, false].includes(value)) {
      continue
    }
    if (typeof value === 'object' && value.length === 0) {
      continue
    }
    result[key] = value
  }
  return result
}

export function clearSession () {
  AuthService.deauthorize();
}

export function Base64Decode (str) {
  return atob(str)
}

export function fetchUserPermissions (permissions) {
  const token = AuthService.getToken();
  if (!token) return []
  let payload = token.split('.')[1]
  payload = JSON.parse(Base64Decode(payload))
  if (!payload['scopes']) return []
  for (let key in payload['scopes']) {
    payload = Object.assign(payload, payload['scopes'][key])
  }
  return payload;
}
